import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import {
  formatTalkDownAssignedTo,
  formatTalkDownDuration,
  TalkDownMessage,
} from "./talkDownMessageTypes";

const formatRecordedDate = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const TalkDownMessagesTable = ({
  rows,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onOpenDetail,
}: {
  rows: TalkDownMessage[];
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  onOpenDetail: (message: TalkDownMessage) => void;
}) => {
  const visible = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", minWidth: 700 }}>
      <TableContainer
        sx={{
          maxHeight: window.innerHeight - 205,
          width: window.innerWidth - 150,
        }}
      >
        <Table stickyHeader sx={{ fontFamily: "Mulish" }} size="small">
          <TableHead>
            <TableRow>
              {[
                "Name",
                "Group",
                "Length",
                "Assigned to",
                "Recorded by",
                "More Info",
              ].map((label) => (
                <TableCell
                  key={label}
                  sx={{
                    fontFamily: "Mulish",
                    fontWeight: 700,
                    backgroundColor: "#fff",
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {visible.map((row) => (
              <TableRow
                key={row.id}
                hover
                sx={{ cursor: "pointer" }}
                onClick={() => onOpenDetail(row)}
              >
                <TableCell sx={{ fontFamily: "Mulish" }}>{row.name}</TableCell>
                <TableCell sx={{ fontFamily: "Mulish" }}>
                  {row.groupName}
                </TableCell>
                <TableCell sx={{ fontFamily: "Mulish" }}>
                  {formatTalkDownDuration(row.durationSeconds)}
                </TableCell>
                <TableCell sx={{ fontFamily: "Mulish" }}>
                  {formatTalkDownAssignedTo(row.assignments)}
                </TableCell>
                <TableCell sx={{ fontFamily: "Mulish" }}>
                  {row.recordedBy}
                </TableCell>
                <TableCell sx={{ fontFamily: "Mulish" }}>
                  {formatRecordedDate(row.recordedAt)}
                </TableCell>
              </TableRow>
            ))}
            {!visible.length && (
              <TableRow>
                <TableCell
                  colSpan={6}
                  align="center"
                  sx={{ fontFamily: "Mulish", py: 4 }}
                >
                  No talk down messages found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_e, next) => onPageChange(next)}
        onRowsPerPageChange={(e) => {
          onRowsPerPageChange(parseInt(e.target.value, 10));
          onPageChange(0);
        }}
        sx={{ fontFamily: "Mulish" }}
      />
    </Paper>
  );
};
